import { MOKA_BUNDLE_PACKAGE_API, MOKA_INVENTORY_API } from '../../constants';

export const V1_BUNDLE_PACKAGE = `${MOKA_BUNDLE_PACKAGE_API}/v1/bundles`;
export const UPLOAD_BUNDLE_PACKAGE_IMAGE = `${MOKA_BUNDLE_PACKAGE_API}/v1/bundles/upload-image`;
export const CREATE_BUNDLE_PACKAGE = `${MOKA_BUNDLE_PACKAGE_API}/v1/bundles`;
export const UPDATE_BUNDLE_PACKAGE = (id) =>
  `${MOKA_BUNDLE_PACKAGE_API}/v1/bundles/${id}`;
export const DELETE_BUNDLE_PACKAGE = (id) =>
  `${MOKA_BUNDLE_PACKAGE_API}/v1/bundles/${id}`;
export const GET_INTERSECT_SALES_TYPES = `${MOKA_INVENTORY_API}/v1/sales-type/intersect-sales-types`;
export const GET_UNION_ITEM_NAMES = `${MOKA_INVENTORY_API}/v1/items/union-item-names`;
export const GET_UNION_ITEM_VARIANT_NAMES = `${MOKA_INVENTORY_API}/v1/items/union-item-variant-names`;

export const GET_UPDATE_STATUS_BUNDLE = (id) =>
  `${MOKA_BUNDLE_PACKAGE_API}/v1/bundles/${id}/status`;
